import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { frDate } from "@/lib/constants";

export default function ReserveDialog({ open, onOpenChange, detail, res, setRes, events, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-zinc-800 bg-zinc-950">
        <DialogHeader><DialogTitle className="text-white">Réserver « {detail?.name} »</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-zinc-400">Événement</Label>
            <Select value={res.event_id || "none"} onValueChange={(v) => setRes({ ...res, event_id: v === "none" ? "" : v })}>
              <SelectTrigger data-testid="reserve-event" className="mt-1 border-zinc-800 bg-zinc-900"><SelectValue placeholder="Aucun (blocage de date)" /></SelectTrigger>
              <SelectContent className="border-zinc-800 bg-zinc-900">
                <SelectItem value="none">Aucun (blocage de date)</SelectItem>
                {events.map((e) => <SelectItem key={e.id} value={e.id}>{e.title} — {frDate(e.date)}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-zinc-400">Du</Label><Input data-testid="reserve-start" type="date" className="mt-1 border-zinc-800 bg-zinc-900" value={res.start_date} onChange={(e) => setRes({ ...res, start_date: e.target.value })} /></div>
            <div><Label className="text-zinc-400">Au</Label><Input data-testid="reserve-end" type="date" className="mt-1 border-zinc-800 bg-zinc-900" value={res.end_date} onChange={(e) => setRes({ ...res, end_date: e.target.value })} /></div>
          </div>
          <div><Label className="text-zinc-400">Quantité</Label><Input data-testid="reserve-qty" type="number" min={1} className="mt-1 border-zinc-800 bg-zinc-900" value={res.quantity} onChange={(e) => setRes({ ...res, quantity: e.target.value })} /></div>
          <Button data-testid="confirm-reserve" onClick={onConfirm} className="w-full rounded-full bg-[#FF6A00] font-semibold text-white hover:bg-[#E65F00]">Confirmer la réservation</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
